import btcChainImg from 'assets/brc20/btc_chain.png'
import bscChainImg from 'assets/brc20/bsc_chain.png'

import ordiImg from "assets/brc20/ordi.png"
import satsImg from "assets/brc20/sats.png"
import ratsImg from "assets/brc20/rats.png"
import miceImg from "assets/brc20/mice.png"
import efilImg from "assets/brc20/efil.png"
import turtImg from "assets/brc20/turt.png"
import betfImg from "assets/brc20/betf.png"

import catsImg from "assets/brc20/cats.png"
import roupImg from "assets/brc20/roup.png"
import MMSSImg from "assets/brc20/MMSS.png"
import SqtsImg from "assets/brc20/Sqts.png"
import DoviImg from "assets/brc20/Dovi.png"
import FBTCImg from "assets/brc20/FBTC.png"
import BTCsImg from "assets/brc20/BTCs.png"
import STSTImg from "assets/brc20/STST.png"
import piinImg from "assets/brc20/piin.png"
import csasImg from "assets/brc20/csas.png"
import biisImg from "assets/brc20/biis.png"
import tracImg from "assets/brc20/trac.png"
import ONFIImg from "assets/brc20/ONFI.png"

import xingImg from "assets/brc20/xing.png"
import chaxImg from "assets/brc20/chax.png"
import dracImg from "assets/brc20/drac.png"
import bankImg from "assets/brc20/bank.png"
import GHSYImg from "assets/brc20/GHSY.png"
import fooxImg from "assets/brc20/foox.png"
import BNSxImg from "assets/brc20/BNSx.png"
import RDEXImg from "assets/brc20/RDEX.png"
import $BMPImg from "assets/brc20/$BMP.png"
import _comImg from "assets/brc20/_com.png"
import FFanImg from "assets/brc20/FFan.png"
import PECLImg from "assets/brc20/PECL.png"
import HOUSE30Img from "assets/brc20/house_30.png"
import HOUSE31Img from "assets/brc20/house_30.png"
import HOUSE32Img from "assets/brc20/house_30.png"
import HOUSE33Img from "assets/brc20/house_30.png"
import HOUSE34Img from "assets/brc20/house_30.png"
import RIFOImg from "assets/brc20/RIFO.png"

export const Brc20Tokens = [
    {
        "index": 1,
        "name": "ordi",
        "symbol": "ordi",
        "imgUrl": ordiImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0x23d7E59EA70fF503FdDcD790ea49D08257F4cDeC",
                "decimals": 18,
            }
        }
    },
    {
        "index": 2,
        "name": "sats",
        "symbol": "sats",
        "imgUrl": satsImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0x265D52B998213dB7ab1655D37636fB4D51f22ADE",
                "decimals": 18,
            }
        }
    },
    {
        "index": 3,
        "name": "rats",
        "symbol": "rats",
        "imgUrl": ratsImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0xD66614085b5410d7Db68a9c68F343C802B3F6F28",
                "decimals": 18,
            }
        }
    },
    {
        "index": 4,
        "name": "mice",
        "symbol": "mice",
        "imgUrl": miceImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0x122E807B359BF82E2D4b9e146ba6950aC0A52D61",
                "decimals": 18,
            }
        }
    },
    {
        "index": 5,
        "name": "EFIL",
        "symbol": "EFIL",
        "imgUrl": efilImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0x03CDe8C2F3b53aDd0ca0e34983C86C047985b2bE",
                "decimals": 18,
            }
        }
    },
    {
        "index": 6,
        "name": "TURT",
        "symbol": "TURT",
        "imgUrl": turtImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0x97e2d3E36E6E7D16dbDAd87Ec8B67Ce7042f6eD3",
                "decimals": 18,
            }
        }
    },
    {
        "index": 7,
        "name": "BETF",
        "symbol": "BETF",
        "imgUrl": betfImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0xAF37eFC77F2676B4147D3673Ed53659e479b1DF4",
                "decimals": 18,
            }
        }
    },
    {
        "index": 8,
        "name": "cats",
        "symbol": "cats",
        "imgUrl": catsImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0x4b5577B3fE33C9d87d335E67f4aE61EfDAfCd4f9",
                "decimals": 18,
            }
        }
    },
    {
        "index": 9,
        "name": "roup",
        "symbol": "roup",
        "imgUrl": roupImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0xB3C66aab6EFA872FA17B610558Eb193B7Aa7DB45",
                "decimals": 18,
            }
        }
    },
    {
        "index": 10,
        "name": "MMSS",
        "symbol": "MMSS",
        "imgUrl": MMSSImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0xfa605eDa2ec038B1fF1B7B580062339C4A3f04eb",
                "decimals": 18,
            }
        }
    },
    {
        "index": 11,
        "name": "Sqts",
        "symbol": "Sqts",
        "imgUrl": SqtsImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0x2C2acF3F7fEc5d8CF9e9feE8405bA688621862FA",
                "decimals": 18,
            }
        }
    },
    {
        "index": 12,
        "name": "Dovi",
        "symbol": "Dovi",
        "imgUrl": DoviImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0xDB1c5041254d06FF83F3455b2C55138bfAc9e325",
                "decimals": 18,
            }
        }
    },
    {
        "index": 13,
        "name": "FBTC",
        "symbol": "FBTC",
        "imgUrl": FBTCImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0x3a499d31465879F205033480C8E60314d2Ad56a1",
                "decimals": 18,
            }
        }
    },
    {
        "index": 14,
        "name": "BTCs",
        "symbol": "BTCs",
        "imgUrl": BTCsImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0x9b0dd35F64A8471DF391ee581159263642692e55",
                "decimals": 18,
            }
        }
    },
    {
        "index": 15,
        "name": "STST",
        "symbol": "STST",
        "imgUrl": STSTImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0x015d610221D5d41617608bE1F49e5CF92Ab3262A",
                "decimals": 18,
            }
        }
    },
    {
        "index": 16,
        "name": "piin",
        "symbol": "piin",
        "imgUrl": piinImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0xddEd49e61DA2867C6990db841DE40caA6A04DA44",
                "decimals": 18,
            }
        }
    },
    {
        "index": 17,
        "name": "csas",
        "symbol": "csas",
        "imgUrl": csasImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0xF412bDa3B4ee19Ecb6DC61E7ac23c5A1162AA395",
                "decimals": 18,
            }
        }
    },
    {
        "index": 18,
        "name": "biis",
        "symbol": "biis",
        "imgUrl": biisImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0x4bf4DA2748fAc5f6CD900DBB3dC81c575C4f486E",
                "decimals": 18,
            }
        }
    },
    {
        "index": 19,
        "name": "trac",
        "symbol": "trac",
        "imgUrl": tracImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0xb0dB714325068281Ee2704a8B9E73933d076e973",
                "decimals": 18,
            }
        }
    },
    {
        "index": 20,
        "name": "ONFI",
        "symbol": "ONFI",
        "imgUrl": ONFIImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0xc5A97B50275FF4c1b60e8256368e3A3e5298acC0",
                "decimals": 18,
            }
        }
    },
    {
        "index": 21,
        "name": "xing",
        "symbol": "xing",
        "imgUrl": xingImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0xa25f3cE41Aab56A191149e714B98353dbf17b806",
                "decimals": 18,
            }
        }
    },
    {
        "index": 22,
        "name": "chax",
        "symbol": "chax",
        "imgUrl": chaxImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0x69A2D195a2f3562A39E058C4684cd5Ee46227261",
                "decimals": 18,
            }
        }
    },
    {
        "index": 21,
        "name": "drac",
        "symbol": "drac",
        "imgUrl": dracImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0x9d049c7C2cC34a25039c2474D0A42BdDC11FeDe1",
                "decimals": 18,
            }
        }
    },
    {
        "index": 22,
        "name": "bank",
        "symbol": "bank",
        "imgUrl": bankImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0xE804069EB3824E5FbE6a166eFf6826A7cc4515aE",
                "decimals": 18,
            }
        }
    },
    {
        "index": 22,
        "name": "GHSY",
        "symbol": "GHSY",
        "imgUrl": GHSYImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0xAfA73b3A92273a79d62d67F5Ef51f5004B1382d6",
                "decimals": 18,
            }
        }
    },
    {
        "index": 23,
        "name": "foox",
        "symbol": "foox",
        "imgUrl": fooxImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0x81145778EE7e8A43cf558Ee9BE3731B4B9982723",
                "decimals": 18,
            }
        }
    },
    {
        "index": 24,
        "name": "BNSx",
        "symbol": "BNSx",
        "imgUrl": BNSxImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0x3684FB6226EBc18ed8591C5a28918c8Dc30B9Ee0",
                "decimals": 18,
            }
        }
    },
    {
        "index": 25,
        "name": "RDEX",
        "symbol": "RDEX",
        "imgUrl": RDEXImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0xb22d2a110d59817b2E1C76A7741ad58c2D99a484",
                "decimals": 18,
            }
        }
    },
    {
        "index": 26,
        "name": "$BMP",
        "symbol": "$BMP",
        "imgUrl": $BMPImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0x58650bdacF0c8Dbd6F26005BDC522AdaC96AE1b1",
                "decimals": 18,
            }
        }
    },
    {
        "index": 27,
        "name": ".com",
        "symbol": ".com",
        "imgUrl": _comImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0x6C9f12DB1B1e43654508a8Ba847AB3f52BCBA3D1",
                "decimals": 18,
            }
        }
    },
    {
        "index": 28,
        "name": "FFan",
        "symbol": "FFan",
        "imgUrl": FFanImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0x092f2712749a7958E8d124B539bE90D96c86FEA1",
                "decimals": 18,
            }
        }
    },
    {
        "index": 29,
        "name": "PECL",
        "symbol": "PECL",
        "imgUrl": PECLImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0x78353861e96a4A3D757BC7EF6C0dd4F667e6274B",
                "decimals": 18,
            }
        }
    },
    {
        "index": 30,
        "name": "🏠",
        "symbol": "🏠",
        "imgUrl": HOUSE30Img,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0x73BC50c36A408e37B34a22DC5Ceeb0E23A79F447",
                "decimals": 18,
            }
        }
    },
    {
        "index": 31,
        "name": "🈚",
        "symbol": "🈚",
        "imgUrl": HOUSE31Img,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0x5A92cEce1eA6D46680Bf4546cE267bEe70Fa865A",
                "decimals": 18,
            }
        }
    },
    {
        "index": 32,
        "name": "🌝",
        "symbol": "🌝",
        "imgUrl": HOUSE32Img,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0x09010B6c6DdbeBefef8c6FF1F88038b95dBbc99F",
                "decimals": 18,
            }
        }
    },
    {
        "index": 33,
        "name": "🥅",
        "symbol": "🥅",
        "imgUrl": HOUSE33Img,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0xD681c6C73170F636c4739a49660250e17c4A93Bb",
                "decimals": 18,
            }
        }
    },
    {
        "index": 34,
        "name": "❤ ",
        "symbol": "❤ ",
        "imgUrl": HOUSE34Img,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0x0d877ebB7F90db951555537eF6b90f9381FbBd7C",
                "decimals": 18,
            }
        }
    },
    {
        "index": 35,
        "name": "RIFO",
        "symbol": "RIFO",
        "imgUrl": RIFOImg,
        "contracts": {
            "BTC": {
                "address": "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",
                "decimals": 18,
            },
            "BNB": {
                "address": "0x59830eb6B7ab5e9C53C5306a04052ee790Ac5dd8",
                "decimals": 18,
            }
        }
    },
]

export const Brc20Chains = [
    {
        "chainIndex": 1,
        "fullName": "Bitcoin",
        "nickName": "BTC",
        "baseCoin": "BTC",
        "decimals": 18,
        "network": "9990099",
        "imgUrl": btcChainImg
    },
    {
        "chainIndex": 2,
        "fullName": "BNB Chain",
        "nickName": "BNB",
        "baseCoin": "BNB",
        "decimals": 18,
        "network": "56",
        "imgUrl": bscChainImg
    }
]